export default __webpack_public_path__ + "static/media/plus_icon_enable.4dde8183.svg";